import React from "react";

import Card from "../UI/Card";
import "./Passion.css";

const passion = () => (
  <div className="passion-container">
    {/* <h1 className="centerText section-title">Driven by passion</h1> */}
    {/* <div className="lambo">
      <p className="lambo-text">
        Yes, my last name really is Lamborghini, but sadly I don't own one.
        Afterall, where would my surfboard fit??
      </p>
    </div> */}

    <h1 className="centerText section-title">A few things that make me, me!</h1>

    <div className="card-parent">
      <Card
        styles={{ maxWidth: 400, minWidth: 250 }}
        title="Music"
        body="From a young age I started playing the drum set and music became my passion. I'm sort of stuck in 90's grunge, but I love everything from soul, jazz, rock and roll and folk. If it can get my foot tapping, I'll surely ware it out."
      >
        <img style= {{width:'100%'}} title='Front row at Pearl Jam!' src="./img/edvedd.jpg" alt="Pearl Jam performing at the Boston Garden" />
      </Card>

      <Card
        styles={{ maxWidth: 400, minWidth: 250 }}
        body="Ocean"
        title="Ocean"
        body="Growing up, the ocean terrified me and now I can't live without it. From surfing, kitesurfing and sailing to rum cocktails or a beer, when I'm in the water I recharge and the sand wreaks havoc on everything I own."
      >
        <img
        title='Kiteboarding in the US Virgin Islands'
          style={{ width: "100%", minWidth: 250 }}
          src="./img/kiting.jpg"
          alt="Christian kiteboarding in the U.S. Virgin Islands"
        />
      </Card>

      <Card
        styles={{ maxWidth: 400 }}
        title="Terrible comedy"
        body="30 Rock! The home of Saturday Night Live and birth of some of the terribly awesome movies and actors. Nearly anything Rob Schneider does brings me to tears. I'm constantly laughing and have trouble speaking without quoting a classic."
      >
        <img style= {{width:'100%'}} title='30 Rock' style={{ width: "100%" }} src="./img/30Rock.jpg" alt="30 Rockafella Ave, NYC" />
      </Card>
    </div>
  </div>
);

export default passion;



// WEBPACK FOOTER //
// ./src/components/Passion/Passion.js